import { emitir_atas_finais } from "./emitir-atas-finais";
import { emitir_quadro_demonstrativo } from "./emitir-quadro-demonstrativo";
import { emitir_folha_de_rosto } from "./emitir-folha-de-rosto";
import { emitir_ficha_individual_por_turma } from "./emitir-ficha-individual-por-turma";
import { emitir_ficha_individual_por_aluno } from "./emitir-ficha-individual-por-aluno";

const atas_finais = [
  ...emitir_atas_finais,
  ...emitir_quadro_demonstrativo,
  ...emitir_folha_de_rosto,
  ...emitir_ficha_individual_por_turma,
  ...emitir_ficha_individual_por_aluno,
];

export { atas_finais };
